import React, { useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import { getFormattedDate } from "../../functions/time";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { CSVLink } from "react-csv";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const Table = (props) => {
  const {
    currentUsers,
    sortFilteredUsers,
    handleEdit,
    handleDelete,
    switchUser,
    length,
    pagination,
  } = props;
  const [sortDateJoined, setSortDateJoined] = useState(0);
  const [sortNames, setSortNames] = useState(0);
  const [sortLastLogin, setSortLastLogin] = useState(0);
  const firstIndex = (pagination.currentPage - 1) * pagination.usersPerPage;

  return (
    <>
      <div className="count-container">
        <span>
          Showing {firstIndex} - {firstIndex + currentUsers.length} of {length}{" "}
          users
        </span>
      </div>
      <table>
        <thead>
          <tr>
            <th>
              <p
                onClick={() => {
                  sortFilteredUsers("userName", !sortNames);
                  setSortNames((prev) => !prev);
                  setSortDateJoined(false);
                  setSortLastLogin(false);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                Username{" "}
                <p className="ml-1">
                  {!sortNames ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                </p>
              </p>{" "}
            </th>
            <th>Email</th>
            <th>
              {" "}
              <p
                onClick={() => {
                  sortFilteredUsers("registerationDate", !sortDateJoined);
                  setSortDateJoined((prev) => !prev);
                  setSortLastLogin(false);
                  setSortNames(false);
                }}
                className="flex"
              >
                Date Joined{" "}
                {!sortDateJoined ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
              </p>
            </th>
            <th>
              <p
                onClick={() => {
                  sortFilteredUsers("lastLoginTime", !sortLastLogin);
                  setSortLastLogin((prev) => !prev);
                  setSortDateJoined(false);
                  setSortNames(false);
                }}
                className="flex"
              >
                Last Login{" "}
                {!sortLastLogin ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
              </p>
            </th>
            <th style={{ textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map((user, id) => (
            <tr key={user.id}>
              <td>{user.userName}</td>
              <td>{user.email}</td>
              <td>{getFormattedDate(user.registerationDate)}</td>
              <td>{getFormattedDate(user.lastLoginTime)}</td>
              <td className="flex-end">
                <Tooltip title="Edit">
                  <EditIcon className="icons" onClick={() => handleEdit(id)} />
                </Tooltip>
                <Tooltip title={user.isDeleted ? "Inactive" : "Active"}>
                  {user.isDeleted ? (
                    <ToggleOffIcon
                      className="icons"
                      onClick={() => handleDelete(user)}
                    />
                  ) : (
                    <ToggleOnIcon
                      className="icons"
                      onClick={() => handleDelete(user)}
                    />
                  )}
                </Tooltip>
                <Tooltip title="Switch User">
                  <SwitchAccountIcon
                    className="icons"
                    onClick={() => switchUser(user)}
                  />
                </Tooltip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Table;
